import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Alert as AlertActions } from 'actions';
import { translateAlert } from '../utils/helpers';

function Alert({ alert, french, dispatch }) {
  return (
    <StyledAlert active={alert.isVisible} type={alert.type}>
      <CloseButton
        type={alert.type}
        onClick={() => dispatch(AlertActions.hide())}
      >
        &times;
      </CloseButton>

      <AlertHeader type={alert.type}>
        {alert.type &&
          (french
            ? translateAlert(alert.type, french)
            : `${alert.type.charAt(0).toUpperCase()}${alert.type.slice(1)}`)}
      </AlertHeader>
      <AlertMsg type={alert.type}>{translateAlert(alert.msg, french)}</AlertMsg>
    </StyledAlert>
  );
}

export default connect((state) => ({
  alert: state.Alert,
  french: state.Storage.language === 'fr',
}))(Alert);

Alert.propTypes = {
  alert: PropTypes.object.isRequired,
  french: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

Alert.defaultProps = {
  french: false,
};

const StyledAlert = styled.div`
  display: ${(props) => (props.active ? 'block' : 'none')};
  position: fixed;
  bottom: 0.6rem;
  right: 1rem;
  z-index: 9999;
  border-radius: 6px;
  padding: 1rem 3rem;
  text-align: center;
  background-color: ${(props) => background[props.type]};
  box-shadow: 0 0 0 1px ${(props) => colors[props.type]} inset,
    0 0 0 0 transparent;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 0.4rem;
  right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 26px;
  line-height: 1;
  color: ${(props) => colors[props.type]};
  opacity: 0.6;
  padding: 0;

  &:hover {
    opacity: 1;
  }
`;

const AlertHeader = styled.div`
  color: ${(props) => colors[props.type]};
  font-weight: 700;
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
`;

const AlertMsg = styled.div`
  opacity: 0.85;
  color: ${(props) => colors[props.type]};
  max-width: 20rem;
`;

const colors = {
  success: '#2c662d',
  warning: '#0e566c',
  error: '#912d2b',
};

const background = {
  success: '#fcfff5',
  warning: '#f8ffff',
  error: '#fff6f6',
};
